import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '../../../Grid';
import History from './History';
import styles from '../OrderTable/Cards.module.sass';
import own from './Cards.module.sass';

// The ten boxes were ten near-identical copies of the same markup, which is
// why they are now data. Adding the age lines meant touching every one of them
// otherwise, and the next change would have meant the same again.
const CATEGORIES = [
  { key: 'award', label: 'Open Award WO', type: 'Award' },
  { key: 'class_picture', label: 'Open Class Picture WO', type: 'Class+Picture' },
  { key: 'id_card', label: 'Open ID Card WO', type: 'ID+Card' },
  { key: 'locate_image_file', label: 'Open Locate Image File WO', type: 'Locate+Image+File' },
  { key: 'process_image_file', label: 'Open Process Image File WO', type: 'Process+Image+File' },
  { key: 'name_wallets', label: 'Open Name Wallets WO', type: 'Name+Wallets' },
  { key: 'package', label: 'Open Package WO', type: 'Package' },
  { key: 'downloads', label: 'Open Downloads WO', type: 'Downloads' },
  { key: 'refund', label: 'Open Refund WO', type: 'Refund' },
  { key: 'senior', label: 'Open Senior WO', type: 'Senior' },
];

// These brackets used to be unclosed (`q%5Bfoo=bar`). That FILTERED CORRECTLY
// -- Rack's query parser tolerates the missing `%5D` and produces the same
// params either way, verified against both forms -- so closing them is not a
// bug fix. It removes a dependence on that leniency, which is not part of any
// contract we should be leaning on.
const filterHref = (type) => `/admin/work_orders?q%5Bwork_order_type_eq%5D=${type}&q%5Bcompleted_eq%5D=false`;

const SHIPPED_HREF = '/admin/work_orders?q%5Bshipped_24_hours%5D=true';

// One box. `data` is { total, over30, under7 } once the fetch lands, and
// undefined until then — hence the optional chaining rather than a spinner:
// the boxes have always rendered empty for that instant.
const CategoryCard = ({ label, href, data }) => (
  <Grid container item direction="column" alignItems="center" justify="center" xs={2} classes={styles.gridItem}>
    <a className={styles.count} href={href} target="_blank" rel="noreferrer">
      {data?.total}
    </a>
    <p className={styles.cardInfo}>
      {label}
    </p>
    {data && (
      <div className={own.aging}>
        <div>
          {data.over30}
          {' > 30 days'}
        </div>
        <div>
          {data.under7}
          {' < 7 days'}
        </div>
      </div>
    )}
  </Grid>
);

CategoryCard.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  // Absent until the counts fetch lands.
  data: PropTypes.shape({
    total: PropTypes.number,
    over30: PropTypes.number,
    under7: PropTypes.number,
  }),
};

CategoryCard.defaultProps = { data: undefined };

const Cards = () => {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    const fetchCounts = async () => {
      let response = await fetch('/admin/work_orders/counts');
      response = await response.json();
      setCounts(response.data);
    };

    fetchCounts();
  }, []);

  // Nine columns of category boxes (5 per row), leaving three for the flow
  // panel -- it spans both rows, which is why the boxes are nested in their
  // own column rather than sitting in the outer grid. Three, not two: at two
  // the four columns of figures were legible but cramped.
  return (
    <div className={styles.cardsContainer}>
      <Grid container>
        <Grid item xs={9}>
          <Grid container>
            {CATEGORIES.slice(0, 5).map((c) => (
              <CategoryCard key={c.key} label={c.label} href={filterHref(c.type)} data={counts[c.key]} />
            ))}
          </Grid>

          <Grid container>
            {CATEGORIES.slice(5).map((c) => (
              <CategoryCard key={c.key} label={c.label} href={filterHref(c.type)} data={counts[c.key]} />
            ))}
            <Grid
              container
              item
              direction="column"
              alignItems="center"
              justify="center"
              xs={2}
              classes={styles.gridItem}
            >
              <a className={styles.count} href={SHIPPED_HREF} target="_blank" rel="noreferrer">
                {counts.shipped}
              </a>
              <p className={styles.cardInfo}>
                Shipped in the past 24 hours
              </p>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={3}>
          <History />
        </Grid>
      </Grid>
    </div>
  );
};

export default Cards;
